// extracted by mini-css-extract-plugin
export var button = "search-module--button--HRqy1";
export var container = "search-module--container--3zrZK";